<template scope="user">
  <div class>
    <v-toolbar class="mb-3" elevation="0">
      <v-toolbar-title>Pages statiques</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn to="/options/static/create">Nouvelle page</v-btn>
    </v-toolbar>
    <v-card elevation="0">
      <v-card-text>
        <v-data-table :items="list" :headers="headers">
          <template v-slot:item.actions="{ item }">
            <v-btn icon :to="'/options/static/edit/'+item.id">
              <v-icon small>mdi-pencil</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data: () => ({
    headers: [
      { text: "Slug", value: "slug" },
      { text: "Nom", value: "name" },
      { text: "", value: "actions" }
    ]
  }),
  computed: {
    ...mapGetters("static", ["list"])
  },
  mounted() {
    this.initialize();
  },
  methods: {
    ...mapActions("static", { getList: "list" }),
    initialize: function() {
      this.getList();
    }
  }
};
</script>

<style>
</style>